<template>
  <div id="chilldoge">
    <main id="main-content">
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@font-face {
    font-family: RetroGaming;
    src: url('~@/assets/RetroGaming.ttf');
}

#app {
  font-family:  "RetroGaming", sans-serif;
  font-weight: bold;
  text-align: center;
  position: relative;
  overflow: hidden;
}

body {
  margin: 0px;
}

</style>
